"use client";
import { ThemeProvider as NextThemeProvider, useTheme } from "next-themes";
import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ isDark: true, mounted: false });

export function ThemeProvider({ children }) {
  return (
    <NextThemeProvider
      attribute="class"
      defaultTheme="dark"
      enableSystem
      value={{ light: "light", dark: "dark" }}
    >
      <InnerProvider>{children}</InnerProvider>
    </NextThemeProvider>
  );
}

function InnerProvider({ children }) {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  // During SSR and initial hydration, default to dark theme to match the defaultTheme
  const isDark = mounted ? resolvedTheme === "dark" : true;

  return (
    <ThemeContext.Provider value={{ isDark, mounted }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useIsDark = () => {
  const context = useContext(ThemeContext);
  // For backward compatibility, return just the boolean if accessed directly
  return typeof context === "object" ? context.isDark : context;
};

export const useThemeContext = () => useContext(ThemeContext);
